import React from "react";
import { Locale } from "@linkfluence/models/locale";
import { Fieldset, Label, Select } from "@ui-kit/form";
import Input from "@ui-kit/form/text/index";
import Toggle from "@ui-kit/form/toggle";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import { isEmbeddedImageDataviz } from "@radarly/models/cards/dataviz";
import {
  editDisplayLinkOnCard,
  editImageSizeOnCard,
  editURLOnCard,
} from "@radarly/models/cards/editor";
import { EmbeddedCard } from "@radarly/models/cards/model";

export interface SharedPanelsCardEditionSidebarEmbedProps {
  card: EmbeddedCard;
  setCard: (card: Card) => void;
  locale: Locale;
}

export default function SharedPanelsCardEditionSidebarEmbed({
  card,
  setCard,
  locale,
}: SharedPanelsCardEditionSidebarEmbedProps) {
  const sizeOptions = [
    {
      value: "fill" as const,
      label: tr(locale, "INSIGHT_PAGES::EDITOR::EMBEDDED_SIZE_FILL"),
    },
    {
      value: "fit" as const,
      label: tr(locale, "INSIGHT_PAGES::EDITOR::EMBEDDED_SIZE_FIT"),
    },
  ];
  const isImage = isEmbeddedImageDataviz(card.dataviz);

  return (
    <>
      <Fieldset>
        <Label htmlFor="name">
          {tr(locale, "INSIGHT_PAGES::EDITOR::EMBEDDED_URL")}
        </Label>
        <Input
          value={card.dataviz.url}
          onChange={(url) => setCard(editURLOnCard(card, url))}
          placeholder={tr(
            locale,
            "INSIGHT_PAGES::EDITOR::EMBEDDED_URL_PLACEHOLDER"
          )}
        />
      </Fieldset>
      <Fieldset>
        <Label htmlFor="name">
          {tr(locale, "INSIGHT_PAGES::EDITOR::EMBEDDED_DISPLAY_LINK")}
        </Label>
        <Toggle
          label={tr(
            locale,
            "INSIGHT_PAGES::EDITOR::EMBEDDED_DISPLAY_LINK_DESCRIPTION"
          )}
          checked={card.dataviz.displayLink}
          onChange={(_, value) => setCard(editDisplayLinkOnCard(card, value))}
        />
      </Fieldset>
      {isImage && (
        <Fieldset>
          <Label>{tr(locale, "INSIGHT_PAGES::EDITOR::EMBEDDED_SIZE")}</Label>
          <Select
            value={sizeOptions.find((size) => size.value === card.dataviz.size)}
            options={sizeOptions}
            variant="primary"
            onChange={({ value }) => setCard(editImageSizeOnCard(card, value))}
            size="l"
          />
        </Fieldset>
      )}
    </>
  );
}
